//react
import React, { useContext, useEffect, useState } from 'react'
import {
  Map,
  useApiIsLoaded,
  useMapsLibrary,
  AdvancedMarker,
  Pin
} from "@vis.gl/react-google-maps";
import { VariableSizeList, FixedSizeList as List } from 'react-window';
//mui
import { Button, TextField, Switch, FormGroup, FormControlLabel, TableCell, CircularProgress, TableContainer, Table, TableHead, TableRow, TableBody, Tab ,InputAdornment,Snackbar,SnackbarContent, Autocomplete, Checkbox} from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from '@mui/icons-material/Add';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { CheckCircleOutline } from '@mui/icons-material';
//context
import AuthContext from '../../../context/AuthContext';
import DrawerContext from '../../../context/DrawerContext';
import ModalContext from '../../../context/ModalContext';

//component
import './ManageLocationDrawer.scss';
import ManualLocationSync from '../../../common/ManualLocationSync.jsx';

 
import { Delete, EditLocation, LocationOn } from '@mui/icons-material';
import { blue } from '@mui/material/colors';


const DefaultLocation = {
  lat: 37.7749,
  lng: -122.4194,
};

const ManageLocationDrawer = (companyId) => {

  const authCtx = useContext(AuthContext);
  const modalCtx = useContext(ModalContext);
  const drawerCtx = useContext(DrawerContext);

  const [loading, setLoading] = useState(false)
  const [updateCountryLoading, setUpdateCountryLoading] = useState(false)
  const [locationsLoading, setLocationsLoading] = useState(true)
  const [locations, setLocations] = useState([])
  const companyid = companyId?.drawerDetails?.companyDetails?.id;
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [addingFromSearch, setAddingFromSearch] = useState({});
  const [rawSearchResults, setRawSearchResults] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState({ lat: 28.7041, lng: 77.1025 });
  const [newLocation, setNewLocation] = useState({
    title: "",
    address: "",
    phone: "",
    email: "",
    country: "",
    state: "",
    city: "",
    latitude: "",
    longitude: "",
    isRegional: false
  })
  const [countries, setCountries] = useState([]);

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [errorField, setErrorField] = useState({
    title: "",
    address: "",
  })
  const [skipValidation, setSkipValidation] = useState(false);

  useEffect(() => {
    return () => {
      setErrorField({ title: "", address: "" });
      setHasSubmitted(false);
    };
  }, []);

  const getAllCountries = () => {
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/companies/countries`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authCtx.token,
      },
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "success") {
        setCountries([ ...data?.data]);
      }
    })
    .catch((err) => {
      console.error("Error fetching countries:", err);
    });
  };
  
  useEffect(() => {
    getAllCountries();
  }, []);


  const geocoding = useMapsLibrary("geocoding");
  const isLoaded = useApiIsLoaded();

  useEffect(() => {
    void getAddressPosition();
  }, [newLocation.address, geocoding, isLoaded]);

  async function getAddressPosition() {
    if (isLoaded && geocoding) {
      try {
        const geocoder = new geocoding.Geocoder();
        const response = await geocoder.geocode({ address: newLocation.address });
  
        if (response.results.length === 0) {
          setNewLocation(prev => ({
            ...prev,
            latitude: 0,
            longitude: 0
          }));
          throw new Error("No results found for the specified address.");
        }
        const location = response.results[0].geometry.location;
        setNewLocation(prev => ({
          ...prev,
          latitude: location.lat(),
          longitude: location.lng()
        }));
        console.log("Updated location:", {
          lat: location.lat(),
          lng: location.lng()
        });
      } catch (error) {
        setNewLocation(prev => ({
          ...prev,
          latitude: 0,
          longitude: 0
        }));
        if (error.message.includes("ZERO_RESULTS")) {
          console.error("Geocoding failed: No results found for the specified address.");
        } else {
          console.error("An unexpected error occurred:", error.message);
        }
      }
    }
  }

  //Snackbar
  const [open, setOpen] = useState(false);
  const [snackbarContentText, setSnackbarContentText] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const openSnackbar = (option) => {
    if (option === "save") { 
      setOpen(true);
      setSnackbarContentText("Location saved successfully.");
    }
    else if (option === "delete") {
      setOpen(true);
      setSnackbarContentText("Location deleted successfully.");
    }
    else if (option === "add") {
      setOpen(true);
      setSnackbarContentText("New location added successfully.");
    }
    else if (option === "reset") {
      setOpen(true);
      setSnackbarContentText("Location reset successfully.");
    }
    else if (option === "error") {
      setOpen(true);
      setSnackbarContentText("Error occurred while saving or deleting location.");
    }
  };

  
  //Handle Edit Location
  const [editModeOn, setEditModeOn] = useState(false);

  const [initialLocationState, setInitialLocationState] = useState({
    title: "",
    address: "",
    phone: "",
    email: "",
    country: "",
    state: "",
    city: "",
    latitude: "",
    longitude: "",
    isRegional: false
  });
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [locationId, setLocationId] = useState(null);
  const [needsManualCountry, setNeedsManualCountry] = useState(false);

  const roundToPrecision = (value, precision = 7) => {
    if (value === null || value === undefined || value === '') return 0;
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return 0;
    return parseFloat(numValue.toFixed(precision));
  };
  
  const compareLocations = (newLocation, initialLocationState) => {
    const roundedNewLocation = {
      ...newLocation,
      latitude: roundToPrecision(newLocation.latitude),
      longitude: roundToPrecision(newLocation.longitude)
    };
  
    const roundedInitialLocationState = {
      ...initialLocationState,
      latitude: roundToPrecision(initialLocationState.latitude),
      longitude: roundToPrecision(initialLocationState.longitude)
    };
  
    return JSON.stringify(roundedNewLocation) !== JSON.stringify(roundedInitialLocationState);
  };

  useEffect(() => {
    if(skipValidation) {
      setSkipValidation(false);
      return;
    }

    if (editModeOn) {
      const hasChanged = compareLocations(newLocation, initialLocationState);
      const isValid = checkValidations();
      setIsSaveEnabled(hasChanged && isValid);
    } else {
      const isValid = checkValidations();
      setIsSaveEnabled(isValid);
    }
  }, [newLocation, editModeOn]);

  const handleEdit = (location) => {
    console.log(location);
    setErrorField({
      title: "",
      address: "",
      phone: "",
      email: "",
    }); 
    const lat = location?.latitude;
    const lng = location?.longitude;
    if (lat && lng) {
      setLocationId(location.id);
      const locationWithRegional = {
        ...location,
        state: location?.state || "",
        city: location?.city || "",
        isRegional: location.locationType == "regional" ? true : false
      };
      setNewLocation(locationWithRegional);
      setInitialLocationState(locationWithRegional);
      setSelectedPosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "",
      }));
      setEditModeOn(true);
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "Address not found.", 
      }));
    }
  };

  const openSaveModal = async () => {
    handleFindAddress(newLocation?.latitude, newLocation?.longitude);
    const validation = checkValidations();
    if (validation) { 
      modalCtx.setDetails("save-company-manage-location", {handleSaveLocation});
      modalCtx.openModal();
    }

  };

  const handleSaveLocation = async () => {
    
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyid}/location/${locationId}`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        },
        body: JSON.stringify({
          title: newLocation.title,
          address: newLocation.address,
          country: newLocation.country,
          state: newLocation.state,
          city: newLocation.city,
          email: newLocation.email,
          mobile: newLocation.phone, 
          latitude: newLocation.latitude,
          longitude: newLocation.longitude,
          isRegional: newLocation.isRegional || false
        })
      });
  
      const data = await response.json();

      if (data.status === "success") {
        openSnackbar("save");
        getAllLocation(); 
        setNewLocation({
          title: "",
          address: "",
          phone: "",
          email: "",
          country: "",
          state: "",
          city: "",
          latitude: "",
          longitude: "",
          isRegional: false
        });
        setLoading(false);
        setEditModeOn(false);
        drawerCtx.setPageUpdate({page: "Companies", companyId: companyid});
          // setSelectedPosition(userLocation);
      }
    } catch (error) {
      console.log(error);
      console.error('Error saving location:', error);
      setLoading(false);
    }
  };
  

//Finding Address through latitude and longitude
  const handleFindAddress = (lat, lng) => {
    console.log(lat, lng);
  
    if (lat && lng) {
      setSelectedPosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "",
      })); 
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "Address not found.", 
      }));
    }
  };
  
  //Field validation
  const getValidationErrors = () => {
    return {
      title: !newLocation?.title?.trim() ? "Title cannot be empty." : "",
      address: !newLocation?.address?.trim()
        ? "Address cannot be empty."
        : (!newLocation?.latitude && !newLocation?.longitude)
        ? "Address not found."
        : "",
    };
  };
  
  const checkValidations = () => {
    const errors = getValidationErrors();
    const isValid = Object.values(errors).every((error) => error === "");
    if (hasSubmitted) setErrorField(errors);
    if (!editModeOn) setIsSaveEnabled(isValid);
    return isValid;
  };

  //Adding a new location
  const openAddModal = async () => {
    handleFindAddress(newLocation?.latitude, newLocation?.longitude);
    await handleAddNewLocation();
  };

  const handleAddNewLocation = async () => {
    setHasSubmitted(true);
    if(!checkValidations()) return;
    
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyid}/location`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        },
        body: JSON.stringify({
          title: newLocation.title,
          address: newLocation.address,
          country: newLocation.country,
          state: newLocation.state,
          city: newLocation.city,
          email: newLocation.email,
          mobile: newLocation.phone, 
          latitude: newLocation.latitude,
          longitude: newLocation.longitude,
          isRegional: newLocation.isRegional || false
        })
      });

      const data = await response.json();
      if (data.status === "success") {
        if (data.needsManualCountry) {
          setNeedsManualCountry(true);
          setLocationId(data.id);
          setLoading(false);
        } else {
          handleResetLocation();
          openSnackbar("add");
          getAllLocation();
          setLoading(false);
          drawerCtx.setPageUpdate({page: "Companies", companyId: companyid});
          setSelectedPosition(userLocation);
        }
      }
    } catch (error) {
      console.log(error)
      console.error('Error adding location:', error);
      setLoading(false);
    }
  }
  
  // Fetch locations when drawer opens
  useEffect(() => {
    if (companyid) {
      getAllLocation();
    }
  }, [companyid]);

  // Handle page updates
  useEffect(() => {
    if (modalCtx.pageUpdate?.page === "CompaniesLocation") {
      console.log("\n\nPage update requested. Refetching locations...");
      getAllLocation();
      modalCtx.setPageUpdate({ page: "" });
    }
  }, [modalCtx.pageUpdate]);

  //Get all location
  const getAllLocation = () => {
    setLocationsLoading(true);
    const URL = `${process.env.REACT_APP_API_URI}/v3/admin/companies/${companyid}/locations`
    fetch(URL, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: "Bearer " + authCtx.token }
    })
    .then(response => {
      return response.json();
    })    .then(data => {
      if (data.status == 'success') {
        // Sort locations alphabetically by title
        const sortedLocations = (data?.data || []).sort((a, b) => {
          const titleA = (a.title || '').toLowerCase();
          const titleB = (b.title || '').toLowerCase();
          return titleA.localeCompare(titleB);
        });
        setLocations(sortedLocations);
      }
    }).catch(err => {
      console.error(err)
    }).finally(() => {
      setLocationsLoading(false);
    });
  }


  // Get User Location
  const [error, setError] = useState(null);
  const [userLocation, setUserLocation] = useState({ lat: 28.7041, lng: 77.1025 });

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setSelectedPosition({ lat: latitude, lng: longitude });
          setUserLocation({ lat: latitude, lng: longitude });
        },
        (err) => {
          console.error(err);
          setError("Unable to retrieve location. Please allow location access.");
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getUserLocation();
  }, []);

  //Get Address
  const getAddress = async (lat, lng) => {
    if (lat && lng) {
      setSelectedPosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "",
      })); 
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        address: "Address not found.", 
      }));
    }
    const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`;
  
    try {
      const response = await fetch(url);
      const data = await response.json();
  
      if (data.status === 'OK' && data.results.length > 0) {
        // Extract the formatted address from the first result
        const fullAddress = data.results[0].formatted_address;
  
        // Extract the portion after the plus code, if needed (for example "Dhandadihi, West Bengal, India")
        const addressParts = fullAddress.split(' ');
        const relevantAddress = addressParts.slice(1).join(' ');  // Remove the first part (J5G6+8F)
        
        console.log('Extracted Address:', relevantAddress);
        setNewLocation((prev) => ({
          ...prev,
          address: relevantAddress,
          latitude: lat,
          longitude: lng
        }));
  
        return relevantAddress;
      } else {
        console.error('No address found for the given coordinates.');
        return 'Address not found';
      }
    } catch (error) {
      console.error('Error fetching address:', error);
      return 'Error fetching address';
    }
  };

  //Delete Location Modal
  const openDeleteLocationModal = (location) => {
    modalCtx.setDetails('delete-company-manage-location', {location});
    modalCtx.openModal();
  }

  //Reset Location
  const handleResetLocation = () => {
    setNewLocation({
      title: "",
      address: "",
      phone: "",
      email: "",
      country: "",
      state: "",
      city: "",
      latitude: "",
      longitude: "",
      isRegional: false
    });
    setErrorField({ title: "", address: "" });
    setHasSubmitted(false);
    setSelectedPosition(userLocation);
    setEditModeOn(false);
  };

  //Drawer Context
  const onCloseDrawer = () => { 
    drawerCtx.closeDrawer();
  }

  //Location Table
  const LocationRow = ({ index, style, data }) => {
    const location = data[index];
    const rowHeight = 76; // Fixed height for consistent spacing
    const requiresManualSync = location?.manualSync === "yes";

    return (
      <TableRow style={{ ...style, display: 'flex', height: rowHeight, opacity: requiresManualSync ? 0.5 : 1, backgroundColor: requiresManualSync ? "#f5f5f5" : "transparent"}} className={`location-row ${requiresManualSync ? "manual-sync-disabled" : ""}`} key={location?.id}>
        <TableCell className="location-col-title-address">
          <div className="title-address-inline">
            <div className="location-title-wrapper">
              <span className="location-title" title={location?.title}>{location?.title}</span>
              {location?.locationType === "regional" && (
                <span className="regional-tag">Regional</span>
              )}
            </div>
            <span className="location-address" title={location?.address}>{location?.address}</span>
          </div>
        </TableCell>
        <TableCell className="location-col-coords">{location.latitude}</TableCell>
        <TableCell className="location-col-coords">{location.longitude}</TableCell>
        <TableCell className="actions">
          <Button style={{justifyContent:"left", minWidth:"25px"}} size="small" onClick={() => handleEdit(location)}disabled={requiresManualSync}>
            <EditIcon fontSize="small" />
          </Button>
          <Button style={{justifyContent:"left", minWidth:"25px"}} size="small" color="error" onClick={() => openDeleteLocationModal(location)}disabled={requiresManualSync}>
            <Delete fontSize="small" />
          </Button>
        </TableCell>
      </TableRow>
    );
  };

  const handleUpdateCountry = async () => {
    try {
      setUpdateCountryLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/location/${locationId}/country`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        },
        body: JSON.stringify({
        country: newLocation.country,
        state: newLocation.state,
        city: newLocation.city
        })
      });

      const data = await response.json();
      
      if (data.status === "success") {
        openSnackbar("save");
        getAllLocation();
        setNeedsManualCountry(false);
        setNewLocation({
          title: "",
          address: "",
          phone: "",
          email: "",
          country: "",
          state: "",
          city: "",
          latitude: "",
          longitude: "",
          isRegional: false
        });
        setErrorField({ title: "", address: "" }); 
        setHasSubmitted(false); 
        setUpdateCountryLoading(false);
        setEditModeOn(false);
        drawerCtx.setPageUpdate({page: "Companies", companyId: companyid});
      }
    } catch (error) {
      console.error('Error updating country:', error);
      setUpdateCountryLoading(false);
      openSnackbar("error");
    }
  };

  const handleTitleChange = (e) => {
    setNewLocation((prev) => ({ ...newLocation, title: e.target.value }));
    setErrorField((prev) => ({ ...errorField, title: "" }));
  }

  const handleAddressChange = (e) => {
    setNewLocation((prev) => ({ ...newLocation, address: e.target.value }));
    setErrorField((prev) => ({ ...errorField, address: "" }));
  }

  // Check if location already exists in company locations
  const isLocationDuplicate = (searchLocation) => {
    return locations.some(existingLocation => {
      // Check by coordinates (most reliable)
      if (existingLocation.latitude && existingLocation.longitude && 
          searchLocation.latitude && searchLocation.longitude) {
        const existingLat = parseFloat(existingLocation.latitude);
        const existingLng = parseFloat(existingLocation.longitude);
        const searchLat = parseFloat(searchLocation.latitude);
        const searchLng = parseFloat(searchLocation.longitude);
        
        // Check if coordinates are very close (within 0.0001 degrees, ~11 meters)
        if (Math.abs(existingLat - searchLat) < 0.0001 && 
            Math.abs(existingLng - searchLng) < 0.0001) {
          return true;
        }
      }
      
      // Also check by address and title combination
      if (existingLocation.address && searchLocation.address &&
          existingLocation.title && searchLocation.title) {
        const existingAddr = existingLocation.address.toLowerCase().trim();
        const searchAddr = searchLocation.address.toLowerCase().trim();
        const existingTitle = existingLocation.title.toLowerCase().trim();
        const searchTitle = searchLocation.title.toLowerCase().trim();
        
        if (existingAddr === searchAddr && existingTitle === searchTitle) {
          return true;
        }
      }
      
      return false;
    });
  };

  // Search for regional locations
  const searchRegionalLocations = async (query) => {
    if (!query || query.trim().length < 2) {
      setSearchResults([]);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/locations/search?q=${encodeURIComponent(query)}&locationType=regional`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        }
      });

      const data = await response.json();
      if (data.status === 'success') {
        // Store raw results and filter
        setRawSearchResults(data.data || []);
        const filteredResults = (data.data || []).filter(location => !isLocationDuplicate(location));
        // Sort alphabetically by title
        const sortedResults = filteredResults.sort((a, b) => {
          const titleA = (a.title || '').toLowerCase();
          const titleB = (b.title || '').toLowerCase();
          return titleA.localeCompare(titleB);
        });
        setSearchResults(sortedResults);
      } else {
        setRawSearchResults([]);
        setSearchResults([]);
      }
    } catch (error) {
      console.error('Error searching locations:', error);
      setRawSearchResults([]);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Debounce search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery.trim().length >= 2) {
        searchRegionalLocations(searchQuery);
      } else {
        setRawSearchResults([]);
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  // Re-filter search results when locations change
  useEffect(() => {
    if (rawSearchResults.length > 0) {
      const filteredResults = rawSearchResults.filter(location => !isLocationDuplicate(location));
      // Sort alphabetically by title
      const sortedResults = filteredResults.sort((a, b) => {
        const titleA = (a.title || '').toLowerCase();
        const titleB = (b.title || '').toLowerCase();
        return titleA.localeCompare(titleB);
      });
      setSearchResults(sortedResults);
    }
  }, [locations]);

  const handleAddFromSearch = async (location) => {
    setAddingFromSearch(prev => ({ ...prev, [location.id]: true }));
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${companyid}/location`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        },
        body: JSON.stringify({
          title: location.title,
          address: location.address,
          country: location.country,
          email: location.email || "",
          mobile: location.phone || "", 
          latitude: location.latitude,
          longitude: location.longitude,
          isRegional: location.locationType === "regional" || false
        })
      });

      const data = await response.json();
      if (data.status === "success") {
        openSnackbar("add");
        getAllLocation();
        // Remove from search results
        setSearchResults(prev => prev.filter(loc => loc.id !== location.id));
      }
    } catch (error) {
      console.error('Error adding location from search:', error);
      openSnackbar("error");
    } finally {
      setLoading(false);
      setAddingFromSearch(prev => ({ ...prev, [location.id]: false }));
    }
  };

  // Extract city and state from address
  const extractCityState = (address) => {
    if (!address) return { city: '', state: '' };
    const parts = address.split(',');
    if (parts.length >= 2) {
      return { city: parts[0].trim(), state: parts[1].trim() };
    }
    return { city: address, state: '' };
  };

  return (
    <div className="drawer-container">
      <div className="drawer">
        <header>
          <h1 data-aos="fade-right" data-aos-delay="500">Manage Locations</h1>
        </header>
      
        <div className='layout-container'>
          <div className='left-container'>
            <div className='map-container'>
              <Map style={{ minHeight: 250 }} center={selectedPosition} defaultZoom={12} mapId={'nhbvasjd8978213clas'} options={{ draggable: true, zoomControl: true, streetViewControl: false, mapTypeControl: true, mapTypeId: 'roadmap', }} >
                {isLoaded && (
                  <AdvancedMarker
                    position={selectedPosition}
                    draggable={true} 
                    onDragEnd={async(event) => {
                      if (event.latLng) {
                        const newLat = event.latLng.lat();
                        const newLng = event.latLng.lng();
                        setSelectedPosition({ lat: newLat, lng: newLng });
                        const address = await getAddress(newLat, newLng);
                        console.log('Address:', address);
                      }
                    }}
                  >
                    <Pin />
                  </AdvancedMarker>
                )}
              </Map>
            </div>
              <div className='locations-textfield' >
                {!needsManualCountry ? (
                  <div className='textfields-container'>
                   <TextField
                      id="standard-basic"
                      variant="standard"
                      name="title"
                      label="Location Title"
                      value={newLocation.title}
                      onChange={handleTitleChange}
                      error={hasSubmitted && !!errorField.title}
                      helperText={hasSubmitted ? errorField.title : " "}
                    />
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      label={newLocation.address ? "Address" : "Search a location"}
                      value={newLocation.address}
                      onChange={handleAddressChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon
                              style={{ color: "#281de4", cursor: "pointer" }}
                              onClick={() => handleFindAddress(newLocation?.latitude, newLocation?.longitude)}
                              disabled={!newLocation.address}
                            />
                          </InputAdornment>
                        ),
                      }}
                      error={hasSubmitted && !!errorField.address}
                      helperText={hasSubmitted ? errorField.address : " "}
                    />
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      name="phone"
                      label="Phone"
                      value={newLocation.phone}
                      onChange={(e) =>
                        setNewLocation((prev) => ({ ...prev, phone: e.target.value }))
                      }
                    />
                    <TextField
                      id="standard-basic"
                      variant="standard"
                      name="email"
                      label="Email"
                      type="email"
                      value={newLocation.email}
                      onChange={(e) =>
                        setNewLocation((prev) => ({ ...prev, email: e.target.value }))
                      }
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={newLocation.isRegional || false}
                          onChange={(e) =>
                            setNewLocation((prev) => ({ ...prev, isRegional: e.target.checked }))
                          }
                        />
                      }
                      label="This is a regional location"
                    />
                  </div>
                ) : (
                  <ManualLocationSync
                    countries={countries}
                    locationDetails={{
                      country: newLocation.country,
                      state: newLocation.state,
                      city: newLocation.city
                    }}
                    onLocationChange={(locationDetails) => {
                      setNewLocation(prev => ({
                        ...prev,
                        country: locationDetails.country,
                        state: locationDetails.state,
                        city: locationDetails.city
                      }));
                    }}
                    onUpdate={handleUpdateCountry}
                    loading={updateCountryLoading}
                  />
                )}
                </div>
                {!needsManualCountry && (
                  <div className='manage-location-buttons'>
                    <Button className='reset-btn' onClick={handleResetLocation}>
                      <RestartAltIcon style={{ marginRight: "4px" }} /> Reset
                    </Button>

                    {editModeOn ? (
                      <Button
                        disabled={!isSaveEnabled || loading}
                        className='location-add-button'
                        onClick={openSaveModal}
                      >
                        {loading ? (
                          <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
                        ) : (
                          <SaveIcon style={{ marginRight: "4px" }} />
                        )}
                        {loading ? "Saving..." : "Save Changes"}
                      </Button>
                    ) : (
                      <Button
                        disabled={!isSaveEnabled || loading}
                        className='location-add-button'
                        onClick={openAddModal}
                      >
                        {loading ? (
                          <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
                        ) : (
                          <AddIcon style={{ marginRight: "4px" }} />
                        )}
                        {loading ? "Adding..." : "Add Location"}
                      </Button>
                    )}
                  </div>
                )}
              <footer>
                <Button variant='outlined' className='btn-primary' onClick={onCloseDrawer}>Close</Button>
                {/* <button disabled={!createBlogObj?.title.length} className='btn-primary' onClick={(e) => submitCreateBlog()}>{loading ? <CircularProgress size={22} style={{color: "#fff"}} /> : "Save"}</button> */}
              </footer>
            </div>
          <div className='table-container'>
            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0' }}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Search for regional locations..."
                value={searchQuery}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {searchQuery.trim().length >= 2 && !searchLoading && (
              <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0' }}>
                {searchResults.length > 0 ? (
                  <>
                    <h3 style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: 600 }}>Search Results</h3>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>City</TableCell>
                            <TableCell>State</TableCell>
                            <TableCell>Country</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell align="right">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {searchResults.map((location) => {
                            const { city, state } = extractCityState(location.address);
                            return (
                              <TableRow key={location.id}>
                                <TableCell>{city}</TableCell>
                                <TableCell>{state}</TableCell>
                                <TableCell>{location.country || ''}</TableCell>
                                <TableCell>{location.title || ''}</TableCell>
                                <TableCell>{location.email || ''}</TableCell>
                                <TableCell align="right">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleAddFromSearch(location)}
                                    disabled={addingFromSearch[location.id] || loading}
                                    startIcon={addingFromSearch[location.id] ? <CircularProgress size={16} /> : <AddIcon />}
                                  >
                                    {addingFromSearch[location.id] ? 'Adding...' : 'Add'}
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    No locations found
                  </div>
                )}
              </div>
            )}
            {searchLoading && (
              <div style={{ padding: '16px', textAlign: 'center' }}>
                <CircularProgress size={24} />
              </div>
            )}
            <TableContainer >
              <Table>
                <TableHead >
                <TableRow className="location-row">
                <TableCell className="location-col-title-address">Title & Address</TableCell>
                  <TableCell className="location-col-coords">Latitude</TableCell>
                  <TableCell className="location-col-coords">Longitude</TableCell>
                  <TableCell className="actions">Actions</TableCell>
                </TableRow>

                </TableHead>
                </Table>
                <Table>
                <TableBody className='location-tbody'>
                  {locationsLoading ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  ) : locations.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No locations found
                      </TableCell>
                    </TableRow>
                  ) : (
                  <VariableSizeList
                    height={Math.min(locations.length * 76, 500)}
                    itemCount={locations.length}
                    itemSize={() => 76}
                    itemData={locations}
                  >
                    {LocationRow}
                  </VariableSizeList>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <SnackbarContent
          style={{
            backgroundColor: 'green',
            borderRadius: '10px',
            color: 'white',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center', 
          }}
          message={
            <span id="client-snackbar" style={{ display: 'flex', alignItems: 'center' }}>
              <CheckCircleOutline style={{ marginRight: '8px', fontSize: '20px' }} />
              {snackbarContentText}
            </span>
          }
        />
      </Snackbar>
    </div>
  )
}

export default ManageLocationDrawer;
